<template>
  <div>
    <div>

      <div class="layout-breadcrumb">
        <Breadcrumb>
          <Breadcrumb-item href="#" >
            <span style="color:#fff;">基础管理</span>
          </Breadcrumb-item>
          <Breadcrumb-item href="#">
          <span style="color:#fff;">物流基础数据</span>
          </Breadcrumb-item>
          <Breadcrumb-item href="#">
          <span style="color:#fff;">供应商到站港维护</span>
          </Breadcrumb-item>
        </Breadcrumb>
      </div>

      <div class="layout-content">

        <div class="layout-content-main">
           <div>
              <Form ref="formStation" :model="formStation"  :label-width="95" >
                    <div class="formLine" >
                       <FormItem label="站(港)名称">
                           <Select v-model="formStation.stationKey" placeholder="请选择站(港)名称" class="special" :label-in-value="true" @on-change="this.selectStation">
                                <Option value="0"><span >站点编码</span><span class="fr">站点名称</span></Option>
                                <Option :value="value.stationName" :label="value.stationName" :key="value.stationId"   v-for="value in stationData"><span>{{value.stationId}}</span><em class="fr">{{value.stationName}}</em></Option>
                           </Select>
                      </FormItem>
                       <FormItem label="省份" >
                          <Select v-model="formStation.provincekey" placeholder="请选择省份" @on-change="this.selectPro">
                            <Option :value ="value" :key="value" v-for="value in provinceData">{{value}}</Option>
                          </Select>
                      </FormItem>
                      <FormItem label="运输方式名称">
                        <Select v-model="formStation.transportKey" placeholder="请选择运输方式">
                            <Option value="1"></Option>
                        </Select>
                      </FormItem>
                    </div>
                    <div class="formLine" style="width:430px">
                      <FormItem label="供应商名称" >
                        <Select v-model="formStation.supplierKey" placeholder="请选择供应商名称" class="special" :label-in-value="true">
                            <Option value="0"><span >供应商代码</span><span class="fr">供应商名称</span></Option>
                            <!-- <Option :value="value.providerName" :key="value.providerName" :label="value.providerName" v-for="value in supplierData"><span >{{value.providerId}}</span><em class="fr">{{value.providerName}}</em></Option> -->
                        </Select>
                      </FormItem>
                    </div>
              </Form>
              <div style="text-align:right;margin-bottom:20px;" >
                    <Button type="ghost" class="mRight" @click="showKeyList()" >查询</Button>
                    <Button @click="addAdmin" type="primary" class="mRight" v-if="isbutShow.addBut">新增</Button>
                    <Button @click="upDateAdmin" type="primary" class="mRight" v-if="isbutShow.updateBut">修改</Button>
                    <Button type="primary" class="mRight" v-if="isbutShow.delBut" @click="delAdmins">删除</Button>
                    
                </div>
          </div>

          

          <div class="table-wrapper">
            <!-- <Table  border :columns="columns4" :data="nodes"></Table> -->
            <Table style="min-width: 700px" border :columns="columns7" :data="pagerData.data" ref="selection" @on-selection-change="getSelection"></Table >
            <div style="margin: 10px;overflow: hidden">
                <div style="float:left">
                     <Button type="primary" size="large" @click="this.exportData"><Icon type="ios-download-outline"></Icon> 下载Excle</Button>
                </div>
                <div style="float: right;">
                    <!-- <Page :total="this.total" :current="1" @on-change="changePage"></Page> -->
                     <Page :total="pagerData.page.totalCount" @on-change="onChange"  show-sizer show-elevator show-total  @on-page-size-change="sizeChange"></Page>
                </div>
            </div>
          </div>

        </div>
      </div>


    </div>

  <!-- 新增admin  / 修改-->
    <Modal
      v-model="addModel"
      title="新增" :mask-closable="false">
        <p slot="header" style="text-align:center">
            <Icon type="information-circled"></Icon>
            <span>{{modelName}}</span>
        </p>
        <div style="text-align:center">
          <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
              <!-- <FormItem label="供应商代码" prop="supplier">
                  <Input v-model="formValidate.supplier" placeholder="请输入供应商代码"></Input>
              </FormItem> -->
              <!-- <FormItem label="站岗代码" prop="siteCode">
                  <Input v-model="formValidate.siteCode"   placeholder="站岗代码"></Input>
              </FormItem> -->
              <FormItem label="供应商名称" prop="suppliername">
                    <Select v-model="formValidate.suppliername" placeholder="请选择供应商名称" class="special">
                        <Option value="0"><span >供应商代码</span><span class="fr">供应商名称</span></Option>
                        <!-- <Option :value="value.providerName"   :label="value.providerName" v-for="value in supplierData"><span >{{value.providerId}}</span><em class="fr">{{value.providerName}}</em></Option> -->
                    </Select>
              </FormItem>
               <FormItem label="站(岗)名称" prop="siteName">
                  <Input v-model="formValidate.siteName"   placeholder="站(岗)名称"></Input>
              </FormItem>
              <FormItem label="省份" prop="province">
                  <Input v-model="formValidate.province" placeholder="请输入省份"></Input>
              </FormItem>
               <FormItem label="运输方式名称" prop="transport">
                  <Input v-model="formValidate.transport" placeholder="请输入运输方式名称"></Input>
              </FormItem>
              <FormItem label="专用线名称" prop="specialName">
                  <Input v-model="formValidate.specialName" placeholder="请输入专用线名称"></Input>
              </FormItem>
          </Form>
        </div>
        <div slot="footer">
             <Button type="primary" @click="handleSubmit('formValidate')" long   :loading="modal_loading" >确定</Button>
        </div>
        
    </Modal>
  
  
  </div>
</template>
<style scoped lang="scss">
  .table-wrapper {
    overflow: scroll;
  }

  .method-wrapper {
    float: left;
    margin-bottom: 10px;
  }
   .fl{
        float:left;
    }
    .fr{
        float:right;
    }
    em{
        font-style: normal;
    }
  .clearfix:after {
    content: ".";
    display: block;
    height: 0;
    visibility: hidden;
    clear: both;
  }
  .mRight{
    margin-right:10px;
  }
  .mLeft{
    margin-left:10px;
  }
  .ivu-breadcrumb a{
    color:#fff !important;
  }
  .formLine{
    /*border: solid 1px red;*/
    display: flex;
  }
  .formLine .ivu-form-item{
    flex:1;
    margin-bottom: 20px;
  }
  .special .ivu-select-dropdown-list li.ivu-select-item:first-child{
      background: #ebf7ff;
      color:#000;
      padding:0;
      height: 30px;
      line-height: 30px;
  }
   .special .ivu-select-dropdown-list li.ivu-select-item:first-child span{
     width: 50%;
    height: 100%;
    display: inline-block;
    text-align: center;
   }
  .activeBut{
    margin-bottom:20px;
  }
</style>
<script>
  import api from '../../api/apinew'
  import axios from 'axios'
  import Qs from 'qs'
  export default{
    data(){
      return {
       isbutShow:{
        addBut: true,
        delBut: true,
        updateBut: true,
        selectBut: true,
       },
        modelName:'新增',
        key:'',
        
        pagerData:{  
           data:[],  
           page:{  
              //分页数  
               // arrPageSize:[10,20,30,40],  
               //分页大小  
               pagesize:10,  
               //总分页数  
               pageCount:1,  
               //当前页面  
               pageCurrent:1,  
               //总数  
               totalCount:0  
           }  

        },
        columns7: [
            {
                type: 'selection',
                width: 60,
                align: 'center'
            },
            {   
                title: '供应商代码',
                key:'providerId',
                // width: 60,
                align: 'center'
            },
            {
                title: '供应商名称',
                key: 'providerName',
                width:120,
                align: 'center',
            },
            {
                title: '站（港）代码',
                key: 'dlvSiteCode',
                align: 'center'
                
            },
            {
                title: '站（港）名称',
                key: 'dlvSiteName',
                align: 'center',
                
            },
            {
                title: '省份',
                key: 'province',
                width:90,
                align: 'center'
            },
            {
                title: '运输方式名称',
                key: 'transportModeName',
                align: 'center',
            },
            {
                title: '专用线名称',
                key: 'privateRouteId',
                align: 'center'
            },
            {
                title: '修改人代码',
                key: 'modiPerson',
                align: 'center'
            },
            {
                title: '修改时间',
                key: 'modiDate',
                align: 'center',
            },
        ],
        addModel: false,
        updateModel:false,
        selectionRows:{},
        updateId:'',
        permissionsLists:[],
        dePtNodeSelect:[],
        formStation: {
            name: '',
            provinces: '',
            type: '',
            stationKey:'',
            provincekey:'',
            transportKey:'',
            supplierKey:'',
            supplierId:''
        },
        
        formValidate: {
            suppliername:'',
            siteName:'',
            province:'',
            transport:'',
            specialName:''
        },
        ruleValidate: {
            suppliername: [
                { required: true, message: '供应商名称不能为空！', trigger: 'blur' }
            ],
            siteName:[
               { required: true, message: '站(岗)名称不能为空！',  trigger: 'blur' }
            ],
            province:[
               { required: true, message: '省份不能为空！',  trigger: 'blur' }
            ],
            transport:[
               { required: true, message: '运输方式名称不能为空！',  trigger: 'blur' }
            ],
            specialName:[
               { required: true, message: '专用线不能为空！',  trigger: 'blur' }
            ],
           
        },
        modal_loading: false,
        stationData:[],
        provinceData:["北京","天津","上海","重庆","河北","山西","辽宁","吉林","黑龙江","江苏","浙江","安徽","福建","江西","山东","河南","湖北","湖南","广东","海南","四川","贵州","云南","陕西","甘肃","青海","内蒙古","广西","西藏","宁夏","新疆维吾尔自治区","香港","澳门","台湾"],
        transportData:[],
        supplierData:[]
      }
    },
    mounted:function(){  
      // ----------- 权限显示start -------------
      var permissions = JSON.parse(localStorage.getItem('menuLeftLists'));
      // 获取当前的地址
      let path = this.$route.matched[1].path ;
      // console.log(this.permissionsLists)
      var len = permissions.length;
     
      for(var i=0;i<len;i++){
          if(path.indexOf(permissions[i].url) != -1){
             this.permissionsLists =  permissions[i].list
          }
      }
      // console.log(this.permissionsLists)
      // 获取权限
      
       // ----------- 权限显示end -------------

        this.getLists(this.pagerData.page.pageCurrent,this.pagerData.page.pagesize);
        this.getStation(this.pagerData.page.pageCurrent,this.pagerData.page.pagesize);
        
    },
    methods: {
        getLists(pageCurrent,pagesize){
            // var token = sessionStorage.getItem("token");
            api.supplier.getList({
                'page':pageCurrent,
                'limit':pagesize,
            }, resp => {
              if(resp.code == 0){
               // 获取分页展示list
               this.pagerData.data = resp.page.list;
               this.supplierData = this.pagerData.data;
               // 获取分页总条数
               this.pagerData.page.totalCount = resp.page.totalCount;

               }
              
            }, error => {

            })
        },
        //搜索数据
            //站点
            getStation:function(pageCurrent,pagesize){
                api.site.getList({
               'page': pageCurrent,
               'limit':pagesize
            },response =>{
                if(response.msg == 'success'){
                    this.stationData = response.page.list;
                    console.log(this.stationData)
                }else{
                    this.$Message.error(response.msg);
                }
            });
            },
            selectStation:function(ele){ 
               this.formStation.stationKey = ele.value;
            },
            selectPro:function(ele){
                console.log(ele)
                this.formStation.provincekey = ele;
            },
            // selectSupplier:function(value){
            //     this.
            // },
        // 搜索关键词
        showKeyList(){
              console.log(this.formStation.provincekey)
               api.supplier.getList({
                    'page':this.pagerData.page.pageCurrent,
                    'limit':this.pagerData.page.pagesize,
                    'dlvSiteName':this.formStation.stationKey,
                    'province':this.formStation.provincekey,
                    'transportModeName':this.formStation.transportKey,
                    'providerId':this.formStation.supplierId
                }, resp => {
                  // 获取分页展示list
                  if(resp.code == 0){
                   this.pagerData.data = resp.page.list;
                   // 获取分页总条数
                   this.pagerData.page.totalCount = resp.page.totalCount;
                //    this.formStation.stationKey = '';
                //    this.formStation.provincekey = '';
                //    this.formStation.transportKey = '';
                //    this.formStation.supplierId = '';
                    }
                }, error => {
                  
                })

            
        },
        handleSubmit (name) {
            this.$refs[name].validate((valid) => {
                console.log('dd');
                if (valid) {
                  if(this.modelName == "修改"){
                    api.supplier.editSupplier({
                      "providerName": this.formValidate.suppliername,
                      "dlvSiteName": this.formValidate.siteName,
                      "province": this.formValidate.province,
                      "transportModeName": this.formValidate.transport,
                      "privateRouteId": this.formValidate.specialName
                    }, resp => {
                      // console.log(resp)
                      if(resp.code == 0){
                        this.$Message.success('修改成功!');
                        this.addModel = false;
                        this.getLists(this.pagerData.page.pageCurrent,this.pagerData.page.pagesize);
                      }else{
                           this.$Message.error(resp.msg);
                      }
                    })
                  }else if(this.modelName == "新增"){
                    console.log(this.treeNodeId)
                    api.supplier.addSupplier({
                      "providerName": this.formValidate.suppliername,
                      "dlvSiteName": this.formValidate.siteName,
                      "province": this.formValidate.province,
                      "transportModeName": this.formValidate.transport,
                      "privateRouteId": this.formValidate.specialName
                    }, resp => {
                      console.log(resp)
                      if(resp.code == 0){
                        this.$Message.success('新增成功!');
                        this.addModel = false;
                        this.getLists(this.pagerData.page.pageCurrent,this.pagerData.page.pagesize);
                      }else {
                        this.$Message.error('新增失败：'+ resp.msg);
                      }
                    })
                  }  
                } else {
                    this.$Message.error('请求失败');
                }
            })
           

        },
       
        // 删除/批量删除
        delAdmins(){
            // this.selectionRows = this.getSelection();
            if(this.selectionRows.length == undefined || this.selectionRows.length == 0){
               this.$Message.error('请至少选择一条记录!');
                return;
            }
            var ids = [];
            for(var i=0 ;i < this.selectionRows.length; i++){
                console.log(i);
                ids.push(this.selectionRows[i].id);
            }
            console.log(ids)
            // 执行删除
            this.delAdmin(ids);
        },
        // 新增 初始化数据
        addAdmin:function(){
            this.modelName = '新增';
            this.formValidate = {};
           this.addModel = true;
        },

        // 修改
        upDateAdmin:function(index){
          this.modelName = '修改';
          if(this.selectionRows.length == undefined || this.selectionRows.length == 0){
              this.$Message.error('请选择一条记录!');
              return;
          }
          if(this.selectionRows.length > 1){
             this.$Message.error('一次只能选择一个进行修改!');
             return;
          }
          
          this.formValidate = {
            suppliername: this.selectionRows[0].providerName,
            siteName : this.selectionRows[0].dlvSiteName,
            province : this.selectionRows[0].transportModeName,
            transport : this.selectionRows[0].dlvSiteName,
            specialName: this.selectionRows[0].privateRouteId
          }
          console.log(this.formValidate);
          this.addModel = true;
        },
        // 当前表格选中项
        getSelection:function(selection){
          // console.log(222)
            // console.log(selection)
            this.selectionRows = selection;
            // return selection;
        },

        // 分页 -- 页数改变
        onChange:function(curpage){  
            // alert("当前页面页码是：" + curpage);
            this.pagerData.page.pageCurrent = curpage;
            this.getLists(this.pagerData.page.pageCurrent,this.pagerData.page.pagesize);
        },
        // 分页 -- pageSize 改变
        sizeChange:function(size){
         // alert("当前页面size是：" + size);
          this.pagerData.page.pagesize = size;
          this.getLists(this.pagerData.page.pageCurrent,this.pagerData.page.pagesize);
        } ,
        delAdmin:function(ids){
          // JSON.stringify(userIds)
           api.supplier.delSupplier(ids , resp => {
               console.log(resp)
               if(resp.code == 0){
                 this.$Message.success('删除成功!');
                 this.getLists(this.pagerData.page.pageCurrent,this.pagerData.page.pagesize);
               }else {
                  this.$Message.error(resp.msg);
               }
            })
         
        },
        exportData:function(){
            this.$refs.selection.exportCsv({
                filename: '供应商到站管理列表'
            });
            
        }

    },

      
    }
</script>



// WEBPACK FOOTER //
// supplier.vue?5a6ba8f4